import AppLayout, {
  ErrorBoundary as AppErrorBoundary,
  unstable_settings,
} from "@components/_layout/AppLayout";
import { wrapExpoRouterErrorBoundary } from "@utils/sentry";

export { unstable_settings };
export const ErrorBoundary = wrapExpoRouterErrorBoundary(AppErrorBoundary);
export default AppLayout;
